import rehypeParse from 'rehype-parse';
import rehypeRemark from 'rehype-remark';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkStringify from 'remark-stringify';
import { unified } from 'unified';

export default function htmlToMarkdown(html: string): string {
  const file = unified()
    .use(rehypeParse)
    .use(rehypeSanitize, defaultSchema)
    .use(rehypeRemark)
    .use(remarkStringify, { bullet: '-', listItemIndent: 'one' })
    .processSync(html);

  return String(file);
}
